

function _createGeometry( width, segments ) {
	
	var geometry = new THREE.PlaneGeometry( width, width, segments, segments )
	
	geometry.applyMatrix(
		new THREE.Matrix4().makeRotationX( Math.PI * 0.5 )
	)
	
	return geometry
	
}

function _createTexture( mesh, scene ) {
	
	var img = new Image()
	var texture = new THREE.Texture( img )
	img.src = 'assets/images/cloud1024.png'
	
	texture.wrapT = THREE.RepeatWrapping
	texture.wrapS = THREE.RepeatWrapping
	
	$(img).on('load', function() {
		texture.needsUpdate = true
		scene.add( mesh )
	})
	
	return texture
	
}

function _createMeshGrid( material, width, gridLength, totalPolygonDensity ) {
	
	var geometry = _createGeometry(
		width / gridLength,
		Math.floor( totalPolygonDensity / gridLength )
	)
	
	var meshGrid = new THREE.Object3D()
	
	var mesh
	var step = width / gridLength
	
	for( var i=0; i < gridLength; i++ ) {
		for( var j=0; j < gridLength; j++ ) {
			
			mesh = new THREE.Mesh( geometry, material )
			mesh.frustumCulled = false
			
			meshGrid.add( mesh )
			mesh.position.set(
				i * step,
				0,
				j * step
			)
		}
	}
	
	return meshGrid
}

function _updateModuloMeshGrid( cameraPosition, meshes, width, state ) {
	
	var il = meshes.length
	var halfWidth = width / 2
	
	return function() {
		var position
		
		for( var i=0; i < il; i++ ) {
			
			position = meshes[i].position
	
			position.set(
				( ( position.x - cameraPosition.x + halfWidth ) % width ) + cameraPosition.x - halfWidth,
				position.y,
				( ( position.z - cameraPosition.z + halfWidth ) % width ) + cameraPosition.z - halfWidth
			)
			
		}
		
	}
}

module.exports = function wireTerrain( poem, properties ) {
	
	var config = _.extend({
		width				: 8000,
		heightScale			: 200,
		gridLength			: 16,
		totalPolygonDensity	: 256,
		positionY			: 0,
		height				: 1
	}, properties)
	
	var state = {
		height : config.height
	}
	
	var material = new THREE.ShaderMaterial({
		
		vertexShader    : "#define GLSLIFY 1\n\nuniform sampler2D terrain;\nuniform float heightFactor;\nuniform float width;\nuniform float elapsed;\n\nvarying float height;\nvarying vec2 vUv;\nvarying float vCameraDistance;\n\n//\n// Description : Array and textureless GLSL 2D/3D/4D simplex\n//               noise functions.\n//      Author : Ian McEwan, Ashima Arts.\n//  Maintainer : ijm\n//     Lastmod : 20110822 (ijm)\n//     License : Copyright (C) 2011 Ashima Arts. All rights reserved.\n//               Distributed under the MIT License. See LICENSE file.\n//               https://github.com/ashima/webgl-noise\n//\n\nvec3 mod289_1_0(vec3 x) {\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\n\nvec4 mod289_1_0(vec4 x) {\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\n\nvec4 permute_1_1(vec4 x) {\n     return mod289_1_0(((x*34.0)+1.0)*x);\n}\n\nvec4 taylorInvSqrt_1_2(vec4 r)\n{\n  return 1.79284291400159 - 0.85373472095314 * r;\n}\n\nfloat snoise_1_3(vec3 v)\n  {\n  const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;\n  const vec4  D_1_4 = vec4(0.0, 0.5, 1.0, 2.0);\n\n// First corner\n  vec3 i  = floor(v + dot(v, C.yyy) );\n  vec3 x0 =   v - i + dot(i, C.xxx) ;\n\n// Other corners\n  vec3 g_1_5 = step(x0.yzx, x0.xyz);\n  vec3 l = 1.0 - g_1_5;\n  vec3 i1 = min( g_1_5.xyz, l.zxy );\n  vec3 i2 = max( g_1_5.xyz, l.zxy );\n\n  //   x0 = x0 - 0.0 + 0.0 * C.xxx;\n  //   x1 = x0 - i1  + 1.0 * C.xxx;\n  //   x2 = x0 - i2  + 2.0 * C.xxx;\n  //   x3 = x0 - 1.0 + 3.0 * C.xxx;\n  vec3 x1 = x0 - i1 + C.xxx;\n  vec3 x2 = x0 - i2 + C.yyy; // 2.0*C.x = 1/3 = C.y\n  vec3 x3 = x0 - D_1_4.yyy;      // -1.0+3.0*C.x = -0.5 = -D.y\n\n// Permutations\n  i = mod289_1_0(i);\n  vec4 p = permute_1_1( permute_1_1( permute_1_1(\n             i.z + vec4(0.0, i1.z, i2.z, 1.0 ))\n           + i.y + vec4(0.0, i1.y, i2.y, 1.0 ))\n           + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));\n\n// Gradients: 7x7 points over a square, mapped onto an octahedron.\n// The ring size 17*17 = 289 is close to a multiple of 49 (49*6 = 294)\n  float n_ = 0.142857142857; // 1.0/7.0\n  vec3  ns = n_ * D_1_4.wyz - D_1_4.xzx;\n\n  vec4 j = p - 49.0 * floor(p * ns.z * ns.z);  //  mod(p,7*7)\n\n  vec4 x_ = floor(j * ns.z);\n  vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)\n\n  vec4 x = x_ *ns.x + ns.yyyy;\n  vec4 y = y_ *ns.x + ns.yyyy;\n  vec4 h = 1.0 - abs(x) - abs(y);\n\n  vec4 b0 = vec4( x.xy, y.xy );\n  vec4 b1 = vec4( x.zw, y.zw );\n\n  //vec4 s0 = vec4(lessThan(b0,0.0))*2.0 - 1.0;\n  //vec4 s1 = vec4(lessThan(b1,0.0))*2.0 - 1.0;\n  vec4 s0 = floor(b0)*2.0 + 1.0;\n  vec4 s1 = floor(b1)*2.0 + 1.0;\n  vec4 sh = -step(h, vec4(0.0));\n\n  vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;\n  vec4 a1_1_6 = b1.xzyw + s1.xzyw*sh.zzww ;\n\n  vec3 p0_1_7 = vec3(a0.xy,h.x);\n  vec3 p1 = vec3(a0.zw,h.y);\n  vec3 p2 = vec3(a1_1_6.xy,h.z);\n  vec3 p3 = vec3(a1_1_6.zw,h.w);\n\n//Normalise gradients\n  vec4 norm = taylorInvSqrt_1_2(vec4(dot(p0_1_7,p0_1_7), dot(p1,p1), dot(p2, p2), dot(p3,p3)));\n  p0_1_7 *= norm.x;\n  p1 *= norm.y;\n  p2 *= norm.z;\n  p3 *= norm.w;\n\n// Mix final noise value\n  vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);\n  m = m * m;\n  return 42.0 * dot( m*m, vec4( dot(p0_1_7,x0), dot(p1,x1),\n                                dot(p2,x2), dot(p3,x3) ) );\n  }\n\n\n\n\nvoid main() {\n\n\tvec4 modelPosition = modelMatrix * vec4(position, 1.0);\n\t\n\tvUv = vec2( modelPosition.x, modelPosition.z + elapsed * 0.05 ) / width;\n\t\t\n\tfloat mainHeightShape = texture2D( terrain, vUv * 0.3 ).w;\n\tfloat smallNoiseySurface = texture2D( terrain, vUv * 5.0 ).w;\n\tfloat amountOfSmallNoise = snoise_1_3(vec3(\n\t\tmodelPosition.x * 0.001 * sin( elapsed * 0.001 ),\n\t\tmodelPosition.z * 0.001 * sin( elapsed * 0.001 ),\n\t\telapsed * 0.0001\n\t));\n\t\n\theight = mainHeightShape + (\n\t\tsmallNoiseySurface * smallNoiseySurface * amountOfSmallNoise\n\t);\n\t\n\tvCameraDistance = distance( modelPosition.xyz, cameraPosition );\n\t\n\tvec4 modifiedPosition = vec4(\n\t\tposition.x,\n\t\tposition.y + height * width / 20.0 * heightFactor,\n\t\tposition.z,\n\t\t1.0\n\t);\n\t\n\tgl_Position = projectionMatrix * modelViewMatrix * modifiedPosition;\n\t\n}",
		fragmentShader  : "#define GLSLIFY 1\n\nvec3 hsv2rgb_1_0(vec3 c) {\n  vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);\n  vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n  return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);\n}\n\n\n\nuniform float width;\nuniform float heightFactor;\nuniform float elapsed;\n\nvarying float height;\nvarying vec2 vUv;\nvarying float vCameraDistance;\n\nvoid main() {\n\t\n\tfloat hueX = abs(0.5 - fract(vUv.x * 2.0)) * 2.0;\n\tfloat hueY = abs(0.5 - fract(vUv.y * 2.0)) * 2.0;\n\t\n\tfloat waveSpeed = 0.0005;\n\tfloat waveLength = 0.0001;\n\tfloat wave = mod((vCameraDistance * waveLength + elapsed * waveSpeed), 1.0);\n\t\n    gl_FragColor = vec4(\n\t\thsv2rgb_1_0(\n\t\t\tvec3(\n\t\t\t\t// mod(xHue, 1.0),\n\t\t\t\t(hueX + hueY) * 0.1 + 0.25,\n\t\t\t\tmix(heightFactor, mix(height, 0.5, 0.8), 0.8),\n\t\t\t\tmix(heightFactor, mix(height, 1.2, 0.35), 0.35)\n\t\t\t)\n\t\t),\n\t\t1.0 - wave + 0.2\n\t);\n\t\n\tfloat fogFactor = smoothstep( 0.0, 1.0, vCameraDistance / width );\n\tvec3 fogColor = vec3( 0.14, 0.14, 0.14 );\n\n\tgl_FragColor = mix( gl_FragColor, vec4( fogColor, gl_FragColor.w ), fogFactor );\n\t\n}",

		side:        THREE.DoubleSide,
		wireframe:   true,
		transparent: true,
		
		uniforms: {
			terrain         : { type: 't' },
			heightFactor    : { type: 'f' },
			width           : { type: 'f' },
			elapsed         : { type: 'f' },
		},
		attributes      : {}

	})
	
	var meshGrid = _createMeshGrid(
		material,
		config.width,
		config.gridLength,
		config.totalPolygonDensity
	)
	
	meshGrid.position.y = config.positionY
	
	material.uniforms.terrain.value = _createTexture( meshGrid, poem.scene )
	material.uniforms.width.value = config.width / 2
	material.uniforms.height = state.height
	
	poem.emitter.on( 'update', function( e ) {
		material.uniforms.heightFactor.value = state.height
		material.uniforms.elapsed.value = e.elapsed
	})
	
	poem.emitter.on( 'update', _updateModuloMeshGrid(
		poem.camera.object.position,
		meshGrid.children,
		config.width,
		state
	))
	
	return state
}